module.exports = __webpack_public_path__ + "af42873cd175989de6e52501dd2a7be1.jpg";